(() => {
  const title = document.querySelector('.shopify-policy__title h1');
  const titleBox = document.querySelector('.shopify-policy__title');

  if (!title || !titleBox) return;

  const normalizedTitle = title.textContent
    .trim()
    .toLocaleLowerCase('fr-FR')
    .replace(/[’']/g, "'");

  const policies = {
    'politique de remboursement': {
      className: 'pg-policy-refund',
      eyebrow: 'Poke-Geek · Media Discount 77',
      subtitle: 'Retours, droit de rétractation et conditions de remboursement.'
    },
    "conditions d'utilisation": {
      className: 'pg-policy-terms',
      eyebrow: 'Poke-Geek · Media Discount 77',
      subtitle: "Cadre d’utilisation du site et conditions applicables aux commandes."
    }
  };

  const policy = policies[normalizedTitle];
  if (!policy) return;

  document.body.classList.add('pg-policy-editorial', policy.className);

  let eyebrow = titleBox.querySelector('.pg-policy__eyebrow');
  if (!eyebrow) {
    eyebrow = document.createElement('p');
    eyebrow.className = 'pg-policy__eyebrow';
    titleBox.insertBefore(eyebrow, title);
  }
  eyebrow.textContent = policy.eyebrow;

  let subtitle = titleBox.querySelector('.pg-policy__subtitle');
  if (!subtitle) {
    subtitle = document.createElement('p');
    subtitle.className = 'pg-policy__subtitle';
    title.insertAdjacentElement('afterend', subtitle);
  }
  subtitle.textContent = policy.subtitle;

  const rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  const contentRoot =
    [...rte.children].find((element) => element.querySelector(':scope > h3')) || rte;

  const sourceBanner =
    contentRoot.querySelector(':scope > div:first-child') ||
    rte.querySelector(':scope > div > div:first-child');

  if (sourceBanner) {
    sourceBanner.classList.add('pg-policy-source-banner');
  }

  if (contentRoot.querySelector('.pg-policy-section-card')) return;

  const originalChildren = [...contentRoot.children];
  let currentCard = null;

  originalChildren.forEach((child) => {
    if (child === sourceBanner) return;

    if (child.tagName === 'HR') {
      child.remove();
      currentCard = null;
      return;
    }

    if (child.tagName === 'H3') {
      const card = document.createElement('section');
      card.className = 'pg-policy-section-card';
      contentRoot.insertBefore(card, child);
      card.appendChild(child);
      currentCard = card;
      return;
    }

    if (currentCard) {
      currentCard.appendChild(child);
    }
  });
})();
